import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'searchWorkAllTabLabel'
	| 'searchWorkInputPlaceholder'
	| 'searchWorkJiraTabLabel'
	| 'searchWorkNoResultsState'
	| 'searchWorkGoalsTabLabel'
	| 'searchWorkProjectsTabLabel'
	| 'recentWorkEmptyState'
	| 'recentWorkErrorState'
	| 'recentWorkLoadingLabel'
	| 'searchWorkPinAction'
	| 'searchWorkUnpinAction'
	| 'searchWorkRecentsSectionHeader'
	| 'searchWorkResultsSectionHeader';

const messages: Record<MessageKeys, { id: string; defaultMessage: string; description: string }> =
	defineMessages({
		searchWorkAllTabLabel: {
			id: 'rovo-pins.search-work.searchWorkAllTabLabel',
			defaultMessage: 'All',
			description: 'Tab label for the All tab on the search work panel',
		},
		searchWorkInputPlaceholder: {
			id: 'rovo-pins.search-work.searchWorkInputPlaceholder',
			defaultMessage: 'Search for projects, epics, or goals',
			description: 'Placeholder text for the search input on the search work panel',
		},
		searchWorkJiraTabLabel: {
			id: 'rovo-pins.search-work.searchWorkJiraTabLabel',
			defaultMessage: 'Jira',
			description: 'Tab label for the Jira (epics) tab on the search work panel',
		},
		searchWorkNoResultsState: {
			id: 'rovo-pins.search-work.searchWorkNoResultsState',
			defaultMessage: 'No results found',
			description: 'Heading shown when a Search Work query returns no results',
		},
		searchWorkGoalsTabLabel: {
			id: 'rovo-pins.search-work.searchWorkGoalsTabLabel',
			defaultMessage: 'Goals',
			description: 'Tab label for the Goals tab on the search work panel',
		},
		searchWorkProjectsTabLabel: {
			id: 'rovo-pins.search-work.searchWorkProjectsTabLabel',
			defaultMessage: 'Projects',
			description: 'Tab label for the Projects tab on the search work panel',
		},
		recentWorkEmptyState: {
			id: 'rovo-pins.search-work.recentWorkEmptyState',
			defaultMessage: 'No recent items',
			description: 'Empty state shown when the user has no recently viewed work in a tab',
		},
		recentWorkErrorState: {
			id: 'rovo-pins.search-work.recentWorkErrorState',
			defaultMessage: 'Something went wrong loading recent work',
			description: 'Error state shown when recent work fails to load',
		},
		recentWorkLoadingLabel: {
			id: 'rovo-pins.search-work.recentWorkLoadingLabel',
			defaultMessage: 'Loading recent work',
			description: 'Accessible label for the loading spinner while recent work is fetched',
		},
		searchWorkPinAction: {
			id: 'rovo-pins.search-work.searchWorkPinAction',
			defaultMessage: 'Pin',
			description:
				'Accessible label for the pin button on a search/recent work row that adds the item to the user\u2019s pinned items when clicked',
		},
		searchWorkUnpinAction: {
			id: 'rovo-pins.search-work.searchWorkUnpinAction',
			defaultMessage: 'Unpin',
			description:
				'Accessible label for the pin button on a search/recent work row that removes the item from the user\u2019s pinned items when clicked',
		},
		searchWorkRecentsSectionHeader: {
			id: 'rovo-pins.search-work.searchWorkRecentsSectionHeader',
			defaultMessage: 'Recents',
			description:
				'Section header shown above the list of the user\u2019s recently viewed work (shown when the search box is empty)',
		},
		searchWorkResultsSectionHeader: {
			id: 'rovo-pins.search-work.searchWorkResultsSectionHeader',
			defaultMessage: 'Search results',
			description:
				'Section header shown above the list of search results (shown when a query is entered)',
		},
	});

export default messages;
